import { render, staticRenderFns } from "./importYouzan.vue?vue&type=template&id=464c4b36&scoped=true"
import script from "./importYouzan.vue?vue&type=script&lang=js"
export * from "./importYouzan.vue?vue&type=script&lang=js"
import style0 from "./importYouzan.vue?vue&type=style&index=0&id=464c4b36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464c4b36",
  null
  
)

export default component.exports